import { Paper, Text, Stack, ActionIcon, Group, Button } from "@mantine/core";
import {
    IconBrandFacebook,
    IconBrandInstagram,
    IconBrandTiktok,
    IconBrandGoogle
} from '@tabler/icons-react';
import { useState } from "react";
import { useSelector } from 'react-redux';
import { selectFooterContent } from '../../../redux/selectors/publicSelector';
import DetailsModal from "../details/details.modal";
import colors from '../../../utils/styles';

const FooterSection = () => {
    const [modalData, setModalData] = useState<any>(null);

    const footer = useSelector(selectFooterContent);

    const policyModalData = {
        title: footer.policy.title,
        modalType: 'company-policy',
        description: (
            <Stack gap="md">
                {footer.policy.data.map((item, index) => (
                    <Stack key={index} gap="xs">
                        <Text fw={700}>{item.title}</Text>
                        <Text>{item.description}</Text>
                        {item.options && (
                            <Stack gap="xs">
                                {item.options.map((option, index) => (
                                    <Text key={index}>{option}</Text>
                                ))}
                            </Stack>
                        )}  
                    </Stack>
                ))}
            </Stack>)
    };

    const contactModalData = {
        title: footer.contact.title,
        modalType: 'contact-info',
        description: (
            <Stack gap="md">
                <Text>{footer.contact.description}</Text>

                <Stack gap="xs">
                    <Text>📞 <Text component="a" href={`tel:${footer.contact.phone.mobile}`} style={{ color: 'inherit', textDecoration: 'none' }}>{footer.contact.phone.mobile}</Text></Text>
                    <Text>📞 <Text component="a" href={`tel:${footer.contact.phone.landline}`} style={{ color: 'inherit', textDecoration: 'none' }}>{footer.contact.phone.landline}</Text></Text>
                    <Text>📧 <Text component="a" href={`mailto:${footer.contact.email}`} style={{ color: 'inherit', textDecoration: 'none' }}>{footer.contact.email}</Text></Text>
                </Stack>
            </Stack>
        )
    };

    const workWithUsModalData = {
        title: footer.workWithUs.title,
        modalType: 'work-with-us',
        description: (
            <Stack gap="md">
                <Text fw={700}>{footer.workWithUs.header}</Text>
                <Text>{footer.workWithUs.subheader}</Text>
                <Text style={{ fontStyle: 'italic' }}>{footer.workWithUs.note}</Text>
                
                <Text>{footer.workWithUs.description}</Text>
                
                <Stack gap="xs">
                    <Text>Auditioners can sign up at: <Text component="span" fw={700}>{footer.workWithUs.contact.email}</Text></Text>
                    
                    <Text>Auditioners must also upload:</Text>
                    {footer.workWithUs.contact.requirements.map((req, index) => (
                        <Text key={index}>{req}</Text>
                    ))}
                </Stack>
                
                <Text>{footer.workWithUs.note2}</Text>
                
                <Text fw={500}>{footer.workWithUs.schedule}</Text>
            </Stack>
        )
    };

    const onModalClose = () => {
        setModalData(null);
    };

    return (<>
        <Paper
            style={{
                background: 'rgba(57,67,135,1)',
                marginTop: '50px',
                padding: '50px 80px',
            }}
        >
            <Group justify="space-between">
                <Stack align="flex-start">
                    {/* Social Media Icons */}
                    <Group mb="md" justify="flex-start" mt="md">
                        <ActionIcon
                            component="a"
                            href={footer.socialMedia.facebook}
                            target="_blank"
                            size="xl"
                            radius="xl"
                            variant="filled"
                            style={{ backgroundColor: colors.appYellow, color: colors.appDarkBlue }}
                        >
                            <IconBrandFacebook size={24} />
                        </ActionIcon>
                        <ActionIcon
                            component="a"
                            href={footer.socialMedia.google}
                            target="_blank"
                            size="xl"
                            radius="xl"
                            variant="filled"
                            style={{ backgroundColor: colors.appYellow, color: colors.appDarkBlue }}
                        >
                            <IconBrandGoogle size={24} />
                        </ActionIcon>
                        <ActionIcon
                            component="a"
                            href={footer.socialMedia.instagram}
                            target="_blank"
                            size="xl"
                            radius="xl"
                            variant="filled"
                            style={{ backgroundColor: colors.appYellow, color: colors.appDarkBlue }}
                        >
                            <IconBrandInstagram size={24} />
                        </ActionIcon>
                        <ActionIcon
                            component="a"
                            href={footer.socialMedia.tiktok}
                            target="_blank"
                            size="xl"
                            radius="xl"
                            variant="filled"
                            style={{ backgroundColor: colors.appYellow, color: colors.appDarkBlue }}
                        >
                            <IconBrandTiktok size={24} />
                        </ActionIcon>
                    </Group>
                    <Button
                        variant="transparent"
                        onClick={() => setModalData(contactModalData)}
                        style={{ padding: 0 }}
                    >
                        <Text style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>{footer.contact.title}</Text>
                    </Button>

                    <Button
                        variant="transparent"
                        onClick={() => setModalData(policyModalData)}
                        style={{ padding: 0 }}
                    >
                        <Text style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>{footer.policy.title}</Text>
                    </Button>
                </Stack>

                <Stack align="flex-end" style={{ alignSelf: 'flex-start' }}>
                    <Button
                        variant="transparent"
                        onClick={() => setModalData(workWithUsModalData)}
                        style={{ color: 'white', padding: 10, border: '3px solid white', borderRadius: '10px', width: '200px', height: '100px' }}
                    >
                        <Text style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>{footer.workWithUs.title}</Text>
                    </Button>
                </Stack>
            </Group>
            <Group justify="center">
                <Text style={{ color: 'white', fontSize: '1rem' }}>{footer?.copyright_footer}</Text>
            </Group>
        </Paper>

        {modalData && <DetailsModal
            opened={!!modalData}
            onClose={onModalClose}
            title={modalData.title}
            description={modalData.description}
            yOffset="120px"
        />}
    </>);
};

export default FooterSection;